import React, { useEffect, useState } from 'react';
import { Section } from './ui/Section';
import { Button } from './ui/Button';
import { ExitUpsellPopup } from './ExitUpsellPopup';
import { Check, Shield, Gift, Clock, ChevronDown, ChevronUp, Zap, Ruler, ShoppingCart } from 'lucide-react';
import { trackAddToCart } from '../utils/metaPixel';
const bonusDetails = [{
  number: '01',
  title: 'Checklist Anti-Humedad (12 puntos)',
  subtitle: 'Mil Hojas A Prueba de Clima',
  promise: 'Tu control de calidad en 5 minutos para evitar el hojaldre "chicloso".',
  bullets: ['12 checks antes/durante/después', 'Versión imprimible + versión móvil', 'Tarjeta de emergencia (rescates rápidos)'],
  value: '$9'
}, {
  number: '02',
  title: 'Guía "Corte Limpio"',
  subtitle: 'Herramientas + Técnica + Porciones Perfectas',
  promise: 'Porciones prolijas sin aplastar capas ni embarrar crema.',
  bullets: ['Técnica Corta–Guía–Limpia', 'Checklist pre-corte', 'Tabla de porciones (6/8/10/12)'],
  value: '$11'
}, {
  number: '03',
  title: 'Kit Solución de Problemas',
  subtitle: 'Diagnóstico Rápido (16 fallas + fixes)',
  promise: 'Identifica la falla y aplica el fix correcto en minutos.',
  bullets: ['Tabla síntoma → causa → fix', 'Árbol de decisión rápido', 'Checklist prevención (7 puntos)'],
  value: '$17'
}];
export function OfferSection() {
  const [showBonusDetail, setShowBonusDetail] = useState(false);
  const [bump1, setBump1] = useState(false);
  const [bump2, setBump2] = useState(false);
  const [flashBump1, setFlashBump1] = useState(false);
  const [flashBump2, setFlashBump2] = useState(false);
  const [showUpsell, setShowUpsell] = useState(false);
  // Subtle flash effect on mount to draw attention
  useEffect(() => {
    const t1 = setTimeout(() => setFlashBump1(true), 1200);
    const t2 = setTimeout(() => setFlashBump1(false), 1900);
    const t3 = setTimeout(() => setFlashBump2(true), 2100);
    const t4 = setTimeout(() => setFlashBump2(false), 2800);
    return () => {
      clearTimeout(t1);
      clearTimeout(t2);
      clearTimeout(t3);
      clearTimeout(t4);
    };
  }, []);
  const total = 9 + (bump1 ? 7 : 0) + (bump2 ? 7 : 0);
  // Shopify variant IDs — replace BUMP1_VARIANT_ID and BUMP2_VARIANT_ID with real IDs
  const MAIN_VARIANT = '42538050125895';
  const BUMP1_VARIANT = 'BUMP1_VARIANT_ID'; // TODO: replace with real Shopify variant ID
  const BUMP2_VARIANT = 'BUMP2_VARIANT_ID'; // TODO: replace with real Shopify variant ID
  const getCheckoutUrl = () => {
    if (bump1 && bump2) return 'https://novadigitalventures.com/cart/42541670629447:1';
    if (bump1) return 'https://novadigitalventures.com/cart/42541663486023:1';
    if (bump2) return 'https://novadigitalventures.com/cart/42541671940167:1';
    return 'https://novadigitalventures.com/cart/42538050125895:1';
  };
  const handleCheckout = () => {
    // If no bumps are selected, show upsell popup
    if (!bump1 && !bump2) {
      setShowUpsell(true);
      return;
    }
    // Otherwise proceed normally
    trackAddToCart();
    window.open(getCheckoutUrl(), '_blank');
  };
  const handleUpsellAccept = () => {
    trackAddToCart();
    // Redirect to full bundle URL
    window.open('https://novadigitalventures.com/cart/42541791215687:1', '_blank');
    setShowUpsell(false);
  };
  const handleUpsellDecline = () => {
    trackAddToCart();
    // Redirect to main product only URL
    window.open('https://novadigitalventures.com/cart/42538050125895:1', '_blank');
    setShowUpsell(false);
  };
  return <Section background="cream" className="pb-24" id="oferta" data-id="element-190">
      <style data-id="element-191">{`
        @keyframes bump-flash {
          0%   { box-shadow: 0 0 0 0 rgba(217,119,6,0); }
          30%  { box-shadow: 0 0 0 4px rgba(217,119,6,0.35); }
          70%  { box-shadow: 0 0 0 6px rgba(217,119,6,0.18); }
          100% { box-shadow: 0 0 0 0 rgba(217,119,6,0); }
        }
        .bump-flash { animation: bump-flash 0.7s ease-out; }
      `}</style>

      <div className="max-w-4xl mx-auto" data-id="element-192">
        <div className="bg-white rounded-3xl shadow-xl overflow-hidden border border-stone-100" data-id="element-193">
          <div className="bg-stone-900 p-6 text-center" data-id="element-194">
            <h2 className="text-2xl md:text-3xl font-serif font-bold text-white" data-id="element-195">
              Oferta Especial de Lanzamiento
            </h2>
            <p className="text-amber-400 mt-2 font-medium" data-id="element-196">
              Domina la técnica hoy mismo
            </p>
          </div>

          <div className="p-8 md:p-12 grid md:grid-cols-2 gap-12 items-start" data-id="element-197">
            {/* LEFT: Bonuses panel */}
            <div className="bg-stone-50 p-6 rounded-xl border border-stone-100" data-id="element-198">
              <div className="flex items-center justify-between mb-4" data-id="element-199">
                <h3 className="font-bold text-stone-900 flex items-center gap-2" data-id="element-200">
                  <Gift className="w-5 h-5 text-amber-600" data-id="element-201" />
                  Bonos incluidos hoy
                </h3>
                <span className="inline-flex items-center gap-1 text-xs font-semibold text-amber-700 bg-amber-100 border border-amber-200 px-2 py-0.5 rounded-full" data-id="element-202">
                  <Clock className="w-3 h-3" data-id="element-203" />
                  Solo hoy
                </span>
              </div>

              <div className="space-y-3 mb-4" data-id="element-204">
                <div className="bg-white rounded-lg p-3 border border-stone-200" data-id="element-205">
                  <div className="flex items-start justify-between gap-2" data-id="element-206">
                    <div data-id="element-207">
                      <p className="text-xs font-bold text-amber-700 uppercase tracking-wide mb-0.5" data-id="element-208">
                        Bono 01
                      </p>
                      <p className="text-sm font-semibold text-stone-900 leading-snug" data-id="element-209">
                        Checklist Anti-Humedad (12 puntos)
                      </p>
                      <p className="text-xs text-stone-500 mt-1" data-id="element-210">
                        Tu control de calidad en 5 min para evitar el hojaldre
                        "chicloso".
                      </p>
                    </div>
                    <span className="text-xs font-bold text-stone-400 line-through whitespace-nowrap flex-shrink-0" data-id="element-211">
                      $9
                    </span>
                  </div>
                </div>
                <div className="bg-white rounded-lg p-3 border border-stone-200" data-id="element-212">
                  <div className="flex items-start justify-between gap-2" data-id="element-213">
                    <div data-id="element-214">
                      <p className="text-xs font-bold text-amber-700 uppercase tracking-wide mb-0.5" data-id="element-215">
                        Bono 02
                      </p>
                      <p className="text-sm font-semibold text-stone-900 leading-snug" data-id="element-216">
                        Guía "Corte Limpio"
                      </p>
                      <p className="text-xs text-stone-500 mt-1" data-id="element-217">
                        Porciones prolijas sin aplastar capas ni embarrar crema.
                      </p>
                    </div>
                    <span className="text-xs font-bold text-stone-400 line-through whitespace-nowrap flex-shrink-0" data-id="element-218">
                      $11
                    </span>
                  </div>
                </div>
                <div className="bg-white rounded-lg p-3 border border-stone-200" data-id="element-219">
                  <div className="flex items-start justify-between gap-2" data-id="element-220">
                    <div data-id="element-221">
                      <p className="text-xs font-bold text-amber-700 uppercase tracking-wide mb-0.5" data-id="element-222">
                        Bono 03
                      </p>
                      <p className="text-sm font-semibold text-stone-900 leading-snug" data-id="element-223">
                        Kit Solución de Problemas
                      </p>
                      <p className="text-xs text-stone-500 mt-1" data-id="element-224">
                        Identifica la falla y aplica el fix correcto en minutos.
                      </p>
                    </div>
                    <span className="text-xs font-bold text-stone-400 line-through whitespace-nowrap flex-shrink-0" data-id="element-225">
                      $17
                    </span>
                  </div>
                </div>
              </div>

              <div className="flex items-center justify-between py-3 border-t border-stone-200 mb-3" data-id="element-226">
                <span className="text-xs text-stone-500 font-medium" data-id="element-227">
                  Valor total de bonos
                </span>
                <div className="text-right" data-id="element-228">
                  <span className="text-xs text-stone-400 line-through mr-1" data-id="element-229">
                    $37
                  </span>
                  <span className="text-xs font-bold text-green-600" data-id="element-230">
                    Gratis hoy
                  </span>
                </div>
              </div>

              <button onClick={() => setShowBonusDetail(!showBonusDetail)} className="flex items-center gap-1 text-xs text-amber-700 font-semibold hover:text-amber-900 transition-colors mb-1" data-id="element-231">
                {showBonusDetail ? <>
                    Ver menos <ChevronUp className="w-3.5 h-3.5" data-id="element-232" />
                  </> : <>
                    Leer más sobre los bonos{' '}
                    <ChevronDown className="w-3.5 h-3.5" data-id="element-233" />
                  </>}
              </button>

              {showBonusDetail && <div className="mt-3 space-y-4 border-t border-stone-200 pt-4" data-id="element-234">
                  {bonusDetails.map(bonus => <div key={bonus.number} className="bg-white rounded-lg p-4 border border-stone-200" data-id="element-235">
                      <div className="flex items-start justify-between mb-2" data-id="element-236">
                        <span className="text-xs font-bold text-stone-400 tracking-widest uppercase" data-id="element-237">
                          Bono {bonus.number}
                        </span>
                        <span className="text-xs font-semibold text-stone-500 bg-stone-100 px-2 py-0.5 rounded-full" data-id="element-238">
                          Valor: {bonus.value}
                        </span>
                      </div>
                      <h4 className="font-serif font-bold text-stone-900 text-sm leading-snug mb-0.5" data-id="element-239">
                        {bonus.title}
                      </h4>
                      <p className="text-xs text-amber-700 font-medium mb-2" data-id="element-240">
                        {bonus.subtitle}
                      </p>
                      <p className="text-xs text-stone-600 leading-relaxed mb-3 border-l-2 border-amber-300 pl-2" data-id="element-241">
                        {bonus.promise}
                      </p>
                      <ul className="space-y-1.5" data-id="element-242">
                        {bonus.bullets.map((bullet, i) => <li key={i} className="flex items-start gap-2 text-xs text-stone-700" data-id="element-243">
                            <Check className="w-3.5 h-3.5 text-amber-500 flex-shrink-0 mt-0.5" data-id="element-244" />
                            {bullet}
                          </li>)}
                      </ul>
                    </div>)}
                </div>}
            </div>

            {/* RIGHT: Price + CTA + Order Bumps + Summary */}
            <div data-id="element-245">
              <div className="mb-8" data-id="element-246">
                <span className="text-stone-500 text-lg line-through decoration-red-500 decoration-2" data-id="element-247">
                  $45 USD
                </span>
                <div className="flex items-baseline gap-2" data-id="element-248">
                  <span className="text-5xl font-bold text-stone-900" data-id="element-249">
                    ${total.toFixed(2)}
                  </span>
                  <span className="text-xl text-stone-600 font-medium" data-id="element-250">
                    USD
                  </span>
                </div>
                <div className="mt-2 inline-flex items-center gap-1 text-green-600 bg-green-50 px-2 py-1 rounded text-sm font-bold" data-id="element-251">
                  Ahorras 80% hoy
                </div>
              </div>

              <ul className="space-y-4 mb-8" data-id="element-252">
                <li className="flex items-start gap-3" data-id="element-253">
                  <Check className="w-5 h-5 text-green-500 flex-shrink-0 mt-0.5" data-id="element-254" />
                  <span className="text-stone-700" data-id="element-255">
                    <strong data-id="element-256">Guía Maestra Mil Hojas Pro</strong> (PDF Digital)
                  </span>
                </li>
                <li className="flex items-start gap-3" data-id="element-257">
                  <Check className="w-5 h-5 text-green-500 flex-shrink-0 mt-0.5" data-id="element-258" />
                  <span className="text-stone-700" data-id="element-259">
                    <strong data-id="element-260">Lista de Marcas en EE.UU.</strong> (Walmart, Target,
                    etc)
                  </span>
                </li>
                <li className="flex items-start gap-3" data-id="element-261">
                  <Check className="w-5 h-5 text-green-500 flex-shrink-0 mt-0.5" data-id="element-262" />
                  <span className="text-stone-700" data-id="element-263">
                    <strong data-id="element-264">Checklist de Emergencia</strong> para Humedad Alta
                  </span>
                </li>
                <li className="flex items-start gap-3" data-id="element-265">
                  <Check className="w-5 h-5 text-green-500 flex-shrink-0 mt-0.5" data-id="element-266" />
                  <span className="text-stone-700" data-id="element-267">
                    Acceso Inmediato y de por vida
                  </span>
                </li>
              </ul>

              <Button size="lg" fullWidth className="text-lg mb-3 flex items-center justify-center gap-2" onClick={handleCheckout} data-id="element-268">
                <ShoppingCart className="w-5 h-5" data-id="element-269" />
                Ir al Checkout — ${total.toFixed(2)} USD
              </Button>

              <p className="text-center text-xs text-amber-700 font-medium mb-5" data-id="element-270">
                Compra hoy y desbloquea los Bonos SOLO HOY.
              </p>

              {/* ORDER BUMP #1 */}
              <div onClick={() => setBump1(!bump1)} className={`cursor-pointer rounded-xl border-2 p-4 mb-3 transition-all duration-300 ${bump1 ? 'border-green-500 bg-green-50 shadow-md shadow-green-100' : 'border-dashed border-amber-300 bg-amber-50/60 hover:border-amber-400'} ${flashBump1 ? 'bump-flash' : ''}`} data-id="element-271">
                <div className="flex items-center justify-end mb-3" data-id="element-272">
                  <span className={`text-xs font-bold px-2 py-0.5 rounded-full ${bump1 ? 'bg-green-500 text-white' : 'bg-stone-800 text-amber-300'}`} data-id="element-273">
                    {bump1 ? '✓ Seleccionado' : '★ Altamente Recomendado'}
                  </span>
                </div>

                <div className="flex gap-3 items-start" data-id="element-274">
                  <div className={`w-6 h-6 rounded-md flex-shrink-0 mt-0.5 border-2 flex items-center justify-center transition-all duration-200 ${bump1 ? 'bg-green-500 border-green-500 scale-110' : 'border-stone-300 bg-white'}`} data-id="element-275">
                    {bump1 && <Check className="w-4 h-4 text-white" strokeWidth={3} data-id="element-276" />}
                  </div>
                  <img src="https://cdn.magicpatterns.com/uploads/ooQiVK2GkF8tQH3CF1Puer/order_bump_1.png" alt="5 Rellenos en 5 Minutos" className="w-14 h-14 object-cover rounded-lg flex-shrink-0 border border-stone-200" data-id="element-277" />
                  <div className="flex-1 min-w-0" data-id="element-278">
                    <div className="flex items-center gap-1.5 mb-1" data-id="element-279">
                      <Zap className="w-3.5 h-3.5 text-amber-600 flex-shrink-0" data-id="element-280" />
                      <p className="text-xs font-bold text-amber-700 uppercase tracking-wide leading-tight" data-id="element-281">
                        ¡Espera! ¿Quieres el menú de rellenos "Zero-Fuego"?
                      </p>
                    </div>
                    <p className="text-xs text-stone-600 leading-relaxed mb-2" data-id="element-282">
                      5 rellenos ultra-estables que se hacen solo batiendo y no
                      humedecen tu hojaldre jamás.
                    </p>
                    <div className="flex items-center gap-2" data-id="element-283">
                      <span className="text-sm font-bold text-stone-900" data-id="element-284">
                        $7.00
                      </span>
                      <span className="text-xs text-stone-400 line-through" data-id="element-285">
                        $25.00
                      </span>
                      <span className="text-xs font-semibold text-green-600 bg-green-50 px-1.5 py-0.5 rounded" data-id="element-286">
                        Ahorras 72%
                      </span>
                    </div>
                  </div>
                </div>
                <p className={`text-xs text-center font-semibold mt-3 py-1.5 rounded-lg transition-colors ${bump1 ? 'bg-green-500 text-white' : 'bg-amber-100 text-amber-800'}`} data-id="element-287">
                  {bump1 ? '✓ Añadido — Pack de Rellenos 5 Minutos' : 'SÍ, QUIERO LAS 5 RECETAS EXTRA POR SOLO $7.00'}
                </p>
              </div>

              {/* ORDER BUMP #2 */}
              <div onClick={() => setBump2(!bump2)} className={`cursor-pointer rounded-xl border-2 p-4 mb-5 transition-all duration-300 ${bump2 ? 'border-green-500 bg-green-50 shadow-md shadow-green-100' : 'border-dashed border-amber-300 bg-amber-50/60 hover:border-amber-400'} ${flashBump2 ? 'bump-flash' : ''}`} data-id="element-288">
                <div className="flex items-center justify-end mb-3" data-id="element-289">
                  <span className={`text-xs font-bold px-2 py-0.5 rounded-full ${bump2 ? 'bg-green-500 text-white' : 'bg-stone-800 text-amber-300'}`} data-id="element-290">
                    {bump2 ? '✓ Seleccionado' : '★ Altamente Recomendado'}
                  </span>
                </div>

                <div className="flex gap-3 items-start" data-id="element-291">
                  <div className={`w-6 h-6 rounded-md flex-shrink-0 mt-0.5 border-2 flex items-center justify-center transition-all duration-200 ${bump2 ? 'bg-green-500 border-green-500 scale-110' : 'border-stone-300 bg-white'}`} data-id="element-292">
                    {bump2 && <Check className="w-4 h-4 text-white" strokeWidth={3} data-id="element-293" />}
                  </div>
                  <img src="https://cdn.magicpatterns.com/uploads/m6XCZXf7mSyFNXtbgpKzK4/order_bump_2.png" alt="Planner de Porciones" className="w-14 h-14 object-cover rounded-lg flex-shrink-0 border border-stone-200" data-id="element-294" />
                  <div className="flex-1 min-w-0" data-id="element-295">
                    <div className="flex items-center gap-1.5 mb-1" data-id="element-296">
                      <Ruler className="w-3.5 h-3.5 text-amber-600 flex-shrink-0" data-id="element-297" />
                      <p className="text-xs font-bold text-amber-700 uppercase tracking-wide leading-tight" data-id="element-298">
                        No más desperdicio: cocina la cantidad exacta
                      </p>
                    </div>
                    <p className="text-xs text-stone-600 leading-relaxed mb-2" data-id="element-299">
                      Tablas maestras de medidas exactas para cada tamaño de
                      evento. Porciones perfectas sin caos.
                    </p>
                    <div className="flex items-center gap-2" data-id="element-300">
                      <span className="text-sm font-bold text-stone-900" data-id="element-301">
                        $7.00
                      </span>
                      <span className="text-xs text-stone-500 font-medium" data-id="element-302">
                        Evita errores y ahorra en ingredientes
                      </span>
                    </div>
                  </div>
                </div>
                <p className={`text-xs text-center font-semibold mt-3 py-1.5 rounded-lg transition-colors ${bump2 ? 'bg-green-500 text-white' : 'bg-amber-100 text-amber-800'}`} data-id="element-303">
                  {bump2 ? '✓ Añadido — Planner de Porciones & Medidas' : 'SÍ, AÑADIR EL PLANNER DE MEDIDAS POR SOLO $7.00'}
                </p>
              </div>

              {/* ORDER SUMMARY */}
              <div className="bg-stone-900 rounded-xl p-5 mb-5 text-white" data-id="element-304">
                <div className="flex items-center gap-2 mb-4" data-id="element-305">
                  <ShoppingCart className="w-4 h-4 text-amber-400" data-id="element-306" />
                  <h4 className="font-bold text-sm text-white" data-id="element-307">
                    Mi resumen de compra
                  </h4>
                </div>

                {/* Main product */}
                <div className="space-y-2 mb-3" data-id="element-308">
                  <div className="flex items-center justify-between" data-id="element-309">
                    <span className="text-xs text-stone-300 flex items-center gap-1.5" data-id="element-310">
                      <Check className="w-3 h-3 text-amber-400 flex-shrink-0" data-id="element-311" />
                      Guía Maestra Mil Hojas Pro
                    </span>
                    <span className="text-xs font-bold text-white" data-id="element-312">$9.00</span>
                  </div>

                  {/* Free bonuses */}
                  <div className="flex items-center justify-between" data-id="element-313">
                    <span className="text-xs text-stone-300 flex items-center gap-1.5" data-id="element-314">
                      <Check className="w-3 h-3 text-amber-400 flex-shrink-0" data-id="element-315" />
                      Checklist Anti-Humedad
                    </span>
                    <span className="text-xs font-semibold text-green-400" data-id="element-316">
                      Gratis
                    </span>
                  </div>
                  <div className="flex items-center justify-between" data-id="element-317">
                    <span className="text-xs text-stone-300 flex items-center gap-1.5" data-id="element-318">
                      <Check className="w-3 h-3 text-amber-400 flex-shrink-0" data-id="element-319" />
                      Guía "Corte Limpio"
                    </span>
                    <span className="text-xs font-semibold text-green-400" data-id="element-320">
                      Gratis
                    </span>
                  </div>
                  <div className="flex items-center justify-between" data-id="element-321">
                    <span className="text-xs text-stone-300 flex items-center gap-1.5" data-id="element-322">
                      <Check className="w-3 h-3 text-amber-400 flex-shrink-0" data-id="element-323" />
                      Kit Solución de Problemas
                    </span>
                    <span className="text-xs font-semibold text-green-400" data-id="element-324">
                      Gratis
                    </span>
                  </div>

                  {/* Order bumps (conditional) */}
                  {bump1 && <div className="flex items-center justify-between" data-id="element-325">
                      <span className="text-xs text-amber-300 flex items-center gap-1.5" data-id="element-326">
                        <Check className="w-3 h-3 text-amber-400 flex-shrink-0" data-id="element-327" />
                        Pack Rellenos 5 Minutos
                      </span>
                      <span className="text-xs font-bold text-white" data-id="element-328">
                        $7.00
                      </span>
                    </div>}
                  {bump2 && <div className="flex items-center justify-between" data-id="element-329">
                      <span className="text-xs text-amber-300 flex items-center gap-1.5" data-id="element-330">
                        <Check className="w-3 h-3 text-amber-400 flex-shrink-0" data-id="element-331" />
                        Planner de Porciones & Medidas
                      </span>
                      <span className="text-xs font-bold text-white" data-id="element-332">
                        $7.00
                      </span>
                    </div>}
                </div>

                {/* Total */}
                <div className="border-t border-stone-700 pt-3 flex items-center justify-between mb-4" data-id="element-333">
                  <span className="text-sm font-bold text-white" data-id="element-334">
                    Total hoy
                  </span>
                  <span className="text-lg font-bold text-amber-400" data-id="element-335">
                    ${total.toFixed(2)} USD
                  </span>
                </div>

                {/* Checkout CTA inside summary */}
                <button onClick={handleCheckout} className="w-full bg-amber-500 hover:bg-amber-400 active:bg-amber-600 text-white font-bold py-3 px-4 rounded-xl transition-colors duration-200 text-sm flex items-center justify-center gap-2" data-id="element-336">
                  <ShoppingCart className="w-4 h-4" data-id="element-337" />
                  Ir al Checkout — ${total.toFixed(2)} USD
                </button>
                <p className="text-xs text-stone-400 text-center mt-2" data-id="element-338">
                  Pago seguro · Acceso inmediato
                </p>
              </div>

              <div className="flex items-center justify-center gap-2 text-xs text-stone-500 mb-5" data-id="element-339">
                <Shield className="w-3 h-3" data-id="element-340" />
                Pago 100% Seguro y Encriptado
              </div>

              <div className="flex items-center gap-3 bg-stone-50 rounded-xl p-4 border border-stone-100" data-id="element-341">
                <div className="w-10 h-10 bg-amber-100 rounded-full flex items-center justify-center flex-shrink-0" data-id="element-342">
                  <Shield className="w-5 h-5 text-amber-600" data-id="element-343" />
                </div>
                <div data-id="element-344">
                  <p className="font-bold text-stone-900 text-sm" data-id="element-345">
                    Garantía de Hierro
                  </p>
                  <p className="text-xs text-stone-500" data-id="element-346">
                    Si tu Mil Hojas no cruje, te devuelvo tu dinero. Sin
                    preguntas.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <ExitUpsellPopup isOpen={showUpsell} onClose={() => setShowUpsell(false)} onAccept={handleUpsellAccept} onDecline={handleUpsellDecline} data-id="element-347" />
    </Section>;
}